module.exports = __webpack_public_path__ + "static/img/medicina-preventiva.0bd5616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/medicina-preventiva.png
// module id = TcWa
// module chunks = 0